import React, { useEffect, useState, useRef } from "react";
import "./App";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Services from "./Pages/Services/Services";
import Portfolio from "./Pages/Portfolio/Portfolio";
import Career from "./Pages/Career/Career";
import NotFound from "./Components/NotFound";
import Blog from "./Pages/Blog/Blog";
import Viewblogs from "./Pages/Blog/Viewblogs";
import topArrow from "./Assets/Red_Theme/topArrow.png";
import ViewService from "./Pages/Services/ViewService";
// import PixelTracker from "./Components/PixelTracker";
import Aos from "aos";
import "aos/dist/aos.css";
import Layout from "./Pages/Shared/Layout";

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasMounted, setHasMounted] = useState(false); // Add this line
  const { pathname } = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    setHasMounted(true); // Set to true after mount
    function handleWindowResize() {
      localStorage.setItem("windowWidth", window.innerWidth);
      localStorage.setItem("windowHeight", window.innerHeight);
    }

    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return; // Don't scroll on first load
    }
    window.scrollTo(0, 0); // Scroll to the top on route change
    // Aos.init();
  }, [pathname]);

  useEffect(() => {
    Aos.init(); // or your preferred options
    Aos.refresh();
  }, []);
  
  useEffect(() => {
    const blockShortcuts = (e) => {
      const key = e.key.toLowerCase();

      // Ctrl / Cmd combinations
      if (
        (e.ctrlKey || e.metaKey) &&
        (key === "s" || key === "u" || key === "p")
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // DevTools shortcuts
      if (
        key === "f12" ||
        ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(key))
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    // 🔴 capture = true is IMPORTANT
    document.addEventListener("keydown", blockShortcuts, true);

    return () => {
      document.removeEventListener("keydown", blockShortcuts, true);
    };
  }, []);

  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    document.addEventListener("contextmenu", disableRightClick, true);
    return () =>
      document.removeEventListener("contextmenu", disableRightClick, true);
  }, []);

  return (
    <>
      {/* <PixelTracker /> */}
      <Routes>
        <Route path="/" element={
          <Layout />
        }>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/:id" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ViewService />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/career" element={<Career />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<Viewblogs />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>

      <div className="scroll-to-top">
        {hasMounted &&
          isVisible && ( // Only render after mount
            <button onClick={scrollToTop} className="scroll-button">
              <img
                src={topArrow}
                className="img-fluid"
                alt="Scroll to top"
                title="topArrow"
              />
            </button>
          )}
      </div>
    </>
  );
}
export default React.memo(App);
